import { Legend, Tooltip } from "dependencies/bigScreen/publicChartOptions/options"
export const chartOption1 = {
  styleId:1,
  pluginName: [],
  refreshTime: 90000,
  seriesTempAttributes: {
    // 用于存放数据中的通用配置项
    coordinateType: "" //不带坐标系
  },

  tooltip: new Tooltip("item", {}),
  legend: new Legend({
    show: false,
    left: "center",
    bottom: "top",
    textStyle: {
      fontFamily: "sans-serif",
      color: "rgba(255,255,255,1)",
      fontWeight: 400,
      fontSize: 14
    }
  }),
  radar: {
    // shape: 'circle',
    indicator: [
      { name: "16岁以下", max: 6500 },
      { name: "16-25岁", max: 16000 },
      { name: "26-35岁", max: 30000 },
      { name: "36-45岁", max: 38000 },
      { name: "46-55岁", max: 52000 },
      { name: "56岁以上", max: 25000 }
    ],
    axisName: {
      formatter: "【{value}】",
      color: "rgba(255, 255, 255, 0.8)",
      fontSize: 14,
      fontWeight: 400,
      fontFamily: "sans-serif"
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: "rgba(36, 140, 219, 0.5)",
        width: 1
      }
    },
    axisNameGap: 15,
    splitLine: {
      show: true,
      lineStyle: {
        color: "rgba(36, 140, 219, 0.5)",
        type: "solid",
        width: 1
      }
    },
    splitArea: {
      show: true,
      areaStyle: {
        // color: ["#26C3BE", "#64AFE9"]
        color: []
      }
    },
    // 分割段数
    splitNumber: 5,
    shape: "polygon",
    center: ["50%", "50%"],
    radius: ["0%", "75%"]
  },
  series: [
    {
      name: "志愿者",
      type: "radar",
      data: [
        {
          value: [4200, 3000, 20000, 35000, 50000, 18000],
          name: "数据1",
          lineStyle: {
            type: "solid",
            width: 1,
            color: "#0D97EB"
          },
          symbolSize: 6,
          symbol: "circle",
          itemStyle: {
            color: "#1D76EF",
            borderColor: "#fff",
            borderWidth: 0
          },
          label: {
            show: true,
            color: "rgba(255, 255, 255, 0.6)",
            fontWeight: 600,

            fontSize: 20,
            formatter: "{c}"
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(13, 151, 235, 0)" // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(13, 151, 235, 0.3)" // 100% 处的颜色
                }
              ]
            },
            opacity: 1
          }
        }
        // {
        //   value: [5000, 14000, 28000, 26000, 42000, 21000],
        //   name: "数据2",
        //   lineStyle: {
        //     type: "solid",
        //     width: 4,
        //     color: "rgb(0, 228, 228)"
        //   },
        //   symbolSize: 10,
        //   symbol: "rect",
        //   itemStyle: {
        //     color: "rgb(0, 71, 255)",
        //     borderColor: "rgb(0, 71, 255)",
        //     borderWidth: 0
        //   },
        //   label: {
        //     show: true,
        //     color: "#fff",
        //     fontWeight: "normal",
        //
        //     fontSize: 20,
        //     formatter: "{c}"
        //   },
        //   areaStyle: {
        //     color: {
        //       type: "linear",
        //       x: 0,
        //       y: 0,
        //       x2: 0,
        //       y2: 1,
        //       colorStops: [
        //         {
        //           offset: 0,
        //           color: "rgb(0, 71, 255)" // 0% 处的颜色
        //         },
        //         {
        //           offset: 1,
        //           color: "rgb(0, 228, 228)" // 100% 处的颜色
        //         }
        //       ]
        //     },
        //     opacity: 0.3
        //   }
        // }
      ]
    }
  ]
}
